module.exports = __webpack_public_path__ + "static/media/siddharth-tipu-sultan-palace-trip-banner.62e98739.jpg";